import { MAX_CONTENT_WIDTH, SITE_MIN_MARGIN } from "../const";
import { Box, BoxProps } from "@chakra-ui/react";

export const ContentWidthContainer: React.FC<BoxProps> = (props) => (
  <Box px={SITE_MIN_MARGIN} py={4} w="100%">
    <Box maxW={MAX_CONTENT_WIDTH} mx="auto" {...props} />
  </Box>
);
